import client from './client'
import install from './install'

// 子模块
import api from './api'

/**
 * 管理端 登录验证
 * http://gitlab.yintech.net/spero/vision/backend/spero-author-service
 */
export default class LokiApi {
  constructor (options, vm) {
    if (LokiApi.instance) {
      throw new Error('LokiApi is singleton')
    }
    LokiApi.instance = this
    this.options = options

    client.defaults.baseURL = options.baseURL

    this.api = api
  }
  static getInstance () {
    return LokiApi.instance
  }
}

LokiApi.instance = null
LokiApi.install = install



// WEBPACK FOOTER //
// ./src/apis/loki-api/index.js